import React from 'react'
import styled from 'styled-components'
import { HeaderDropdownItem } from '../../../../ui'
import { DROPDOWN_COPYTRADING_OPTIONS } from '../../constants'
import useLocale from '../../../../../../hooks/useLocale'
import { DEFAULT_LOCALE } from '../../../../../../constants'
import { GATSBY_MAIN_URL } from 'constants/env'

export const DropdownCopytradingNavigate = () => {
  const { locale } = useLocale()

  return (
    <StyledDropdownCopytradingNavigate>
      {DROPDOWN_COPYTRADING_OPTIONS.map(option => {
        const copytradingUrl =
          locale === DEFAULT_LOCALE ? `${GATSBY_MAIN_URL}/copytrading` : `${GATSBY_MAIN_URL}/${locale}/copytrading`

        const to = option.to === '/copytrading' ? copytradingUrl : option.to

        return <HeaderDropdownItem key={option.name} dir='ltr' {...option} to={to} />
      })}
    </StyledDropdownCopytradingNavigate>
  )
}

const StyledDropdownCopytradingNavigate = styled.div`
  width: 361.5px;
  height: 100%;
  padding: 69px 30px 0 18px;
`
